import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DataService, TournamentYear, Tournament, Bracket, BracketRound } from '../services/data-service.service';

@Component({
  selector: 'tourmanents',
  templateUrl: './tourmanents.component.html',
  styleUrls: ['./tourmanents.component.scss']
})
export class TourmanentsComponent implements OnInit {
  public displayBracket = false;
  public displayElimRound = false;
  public displayInfo = false;
  public displayLeaders = false;
  public displayMenu = true;
  public displayQualRound = false;
  public displayTeams = false;
  public expandQualRounds = false;
  public tournamentOrLeague = 'tournament';
  public tournaments: Array<Tournament> = new Array<Tournament>();
  public placementBrackets: Bracket[] = [];
  public qualificationBracket: Bracket;
  public selectedBracket: Bracket;
  public selectedQualRound: BracketRound;
  public selectedRound: BracketRound;
  public selectedYear: TournamentYear;
  
  constructor(public ds: DataService, public translate: TranslateService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.ds.currentTournament = null;
    this.ds.getTournamentYears(() => {
      const year = parseInt(this.route.snapshot.queryParamMap.get('year'));
      const tid = this.route.snapshot.queryParamMap.get('tid');
      if (year) {
        this.selectedYear = this.ds.years.find(y => y.year === year);
        this.onSelectYear(() => {
          if (tid) {
            this.ds.currentTournament = this.ds.tournaments.find(t => t.transferPK === tid);
            this.tournamentOrLeague = this.ds.currentTournament && !this.ds.currentTournament.isTournament ? 'league' : 'tournament';
            this.onChangeTournamentLeague();
            if (this.ds.currentTournament) {
              this.onSelectTournament();
            }
          }
        });
      } 
    });
  }

  public onChangeTournamentLeague(): void {
    if (this.tournamentOrLeague === 'tournament') {
      this.tournaments = this.ds.tournaments.filter((tournament) => tournament.isTournament === true);
    } else {
      this.tournaments = this.ds.tournaments.filter((tournament) => tournament.isTournament === false);
    }
  }

  public onExpandBracket(b: Bracket) {
    if (this.ds.mobile || (!this.ds.mobile && b.hasElimRound)) {
      b.expanded = !b.expanded;
    } else {
      this.showBracket(b, true);
    }
  }

  public onExpandQualification(): void {
    this.expandQualRounds = !this.expandQualRounds;
  }

  public onInformation(): void {
    this.resetTournamentDisplay();
    document.querySelector('#tournament-info').classList.add('tournament-menu-active');
    this.displayInfo = true;
  }

  public onLeaders(): void {
    this.resetTournamentDisplay();
    document.querySelector('#tournament-leader-list').classList.add('tournament-menu-active');
    this.displayLeaders = true;
  }

  public onMobileSelection(): void {
    this.resetTournamentDisplay();
    this.displayMenu = true;
  }

  public resetTournamentDisplay() {
    this.displayInfo = false;
    this.displayLeaders = false;
    this.displayTeams = false;
    this.displayMenu = false;
    this.displayQualRound = false;
    this.displayElimRound = false;
    this.displayBracket = false;
    document.querySelectorAll('.tournament-menu-button').forEach(b => {
      b.classList.remove('tournament-menu-active');
    })
  }

  public onSelectTournament(refresh?: boolean): void {
    const date = new Date();
    date.setMonth(this.ds.currentTournament.month - 1);
    date.setDate(this.ds.currentTournament.day);
    date.setFullYear(this.ds.currentTournament.year);
    this.ds.currentTournament.startDate = date;
    if (!refresh) {
      this.resetTournamentDisplay();
      this.expandQualRounds = false;
    }

    this.ds.getTournamentBrackets(() => {
      this.ds.getTournamentTeams();
      
      this.ds.getTournamentMatchResults(() => {
        this.qualificationBracket = this.ds.currentTournament.brackets.find(b => b.level === 0);
        this.placementBrackets = this.ds.currentTournament.brackets.filter(b => b.level > 0);

        if (!refresh) {
          if (!this.ds.mobile) {
            document.querySelector('#tournament-info').classList.add('tournament-menu-active');
            this.displayInfo = true;
          } else {
            this.displayMenu = true;
          }
        } 
      });
    });
  }

  public onSelectYear(callback?: () => void): void {
    this.ds.getTournamentsByYear(this.selectedYear, () => {
      this.onChangeTournamentLeague();

      if (callback) callback();
    });
  }

  public onTeams(): void {
    this.resetTournamentDisplay();
    document.querySelector('#tournament-teams').classList.add('tournament-menu-active');
    this.displayTeams = true;
  }

  public showBracketRound(b: Bracket, r: BracketRound): void {
    this.selectedBracket = b;
    this.selectedRound = r;
    this.resetTournamentDisplay();
    this.displayBracket = true;
    document.querySelector('#tournament-bracket-' + b.id + '-round-' + r.roundNum).classList.add('tournament-menu-active');

  }

  public showBracket(b: Bracket, unexpandable?: boolean) {
    this.selectedBracket = b;
    this.resetTournamentDisplay();
    setTimeout(() => { this.displayBracket = true; }, 10);
    if (unexpandable) {
      document.querySelector('#tournament-bracket-' + b.id).classList.add('tournament-menu-active');
    } else {
      document.querySelector('#tournament-bracket-' + b.id + '-bracket').classList.add('tournament-menu-active');
    }
  }

  public showEliminationRound(b: Bracket): void {
    this.selectedBracket = b;
    this.selectedRound = this.selectedBracket.rounds.find(r => r.roundNum === 0);
    this.resetTournamentDisplay();
    this.displayElimRound = true;
    document.querySelector('#tournament-bracket-' + b.id + '-round-' + this.selectedRound.roundNum).classList.add('tournament-menu-active');
  }

  public showQualificationRound(r: BracketRound): void {
    this.selectedQualRound = r;
    this.selectedQualRound.matches.sort((a, b) => a.pitchNum > b.pitchNum ? 1 : -1);
    this.resetTournamentDisplay();
    document.querySelector('#qual-round-' + r.roundNum).classList.add('tournament-menu-active');
    this.displayQualRound = true;
  }
}
